import React from 'react';
import { Container } from '../Container';
import { Label } from '../Label';
import { Reveal } from '../Reveal';
export function InfluencerServices() {
  const services = [{
    title: 'Brand Development',
    desc: 'Building a distinct personal brand, positioning, and long-term identity that holds up well past a single trend cycle.'
  }, {
    title: 'Content Creation',
    desc: 'Strategy, production, and editing support that keeps output consistent without burning the creator out.'
  }, {
    title: 'Representation',
    desc: 'Deal negotiation, brand partnerships, contracts, and day-to-day career management.'
  }];
  return <section className="border-b border-brand-gray300 py-[clamp(70px,10vw,140px)]" data-id="element-121" data-mp="2h4pszh7b6d8z">
      <Container data-id="element-122" data-mp="2h6sqsnepdao9">
        <div className="mb-[clamp(40px,6vw,80px)] flex flex-wrap items-end justify-between gap-[40px]" data-id="element-123" data-mp="1dk5xl7vqxgk">
          <Label className="self-start" data-id="element-124" data-mp="3sk4zpcpbkjha">01 · What we handle</Label>
          <h2 className="max-w-[18ch] text-[clamp(2.2rem,5.6vw,5.2rem)] font-black leading-[0.95] tracking-[-0.025em]" data-id="element-125" data-mp="3slzcu4ucn7at">
            Three disciplines. One career.
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-px border-t border-brand-gray300 bg-brand-gray300 max-[900px]:grid-cols-1" data-id="element-126" data-mp="17jq2m1iizun6">
          {services.map((service, index) => <Reveal key={service.title} delay={index * 0.05} className="h-full" data-id="element-127" data-mp="1gl7q44y9iylw" data-mpi={index}>
              <div className="group h-full cursor-pointer bg-brand-white p-[36px_24px] transition-colors duration-200 ease-out hover:bg-brand-black hover:text-brand-white" data-id="element-128" data-mp="jwrmx628cqqb">
                <h3 className="mb-[16px] text-[clamp(1.4rem,2.2vw,2rem)] font-black uppercase tracking-[-0.02em]" data-id="element-129" data-mp="swojdtuv2tvx">
                  {service.title}
                </h3>
                <p className="text-[14px] leading-[1.5]" data-id="element-130" data-mp="xoocb2cikmj0">{service.desc}</p>
              </div>
            </Reveal>)}
        </div>
      </Container>
    </section>;
}